import React from 'react';
import ResourceComponent from '../../../common/ResourceComponent';
import {Button, Col, Tooltip} from 'reactstrap';

class ShareButton extends ResourceComponent {
    render() {
        const {item, showTooltip, copyToClipboard} = this.props;
        return <Col className='m-0 pt-1'>
            <Button
                id={`copy${item.id}`}
                size='sm' color='info'
                onClick={(e) => {
                    e.stopPropagation();
                    copyToClipboard(item.id);
                }}>
                Copy URL
            </Button>
            <Tooltip
                fade={true}
                placement='right'
                isOpen={showTooltip && showTooltip === item.id}
                target={`copy${item.id}`}>
                Copied to clipboard
            </Tooltip>
        </Col>;
    }
}

export default ShareButton;


// WEBPACK FOOTER //
// ./src/containers/embeddable/utils/ShareButton.js